<template>

    <main class="temoignages-body-template">
        <article>
            <section class="text-right">
                <figure>
                    <img class="picture" v-if="item.picture" :src="require('../../assets/' + item.picture)" alt="">
                    <figcaption>
                        <p :class="item.color">BÉRANGÈRE PIOGER</p>
                        <p class="green">FOUNDER OF THE HONORINE LEVE-TOI CHARITY IN BAYEUX (14)</p>
                    </figcaption>
                </figure>

                <p class="number" :class="item.color">
                   2 billion 
                </p>

                <p class="green uppercase semiBold">
                   steps counted in the Healpy app enabled Groupama Sigorta to fund 22 wheelchairs in Turkey.
                </p>


                <img class="icono w300" :src="require('../../assets/t9-2.jpg')">
                <p class="label green" :class="item.color">
                    HEALTH
                </p>

                <p class="green uppercase semiBold">
                    The Social Innovation Award was presented to the Faculty of Dentistry at Reims University for its design of a prototype articulator that facilitates the process of producing dental prostheses for children and teenagers suffering from rare diseases.
                </p>

				<img class="icono w200" :src="require('../../assets/camera.jpg')">
				<p class="label green" :class="item.color">
                    THE GAN FOUNDATION FOR CINEMA
                </p>

                <p class="green uppercase semiBold">
                    Funding provided by the Foundation for 5 feature-length dramas in 2019.
                </p>


            </section>

            <section>
                <svg class="quote" :class="item.color" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59.8 42.61">
                    <path d="M59.8,0H45.59C39,11,34.91,18,33.43,20.83a17.92,17.92,0,0,0-2.17,8.26c0,7.57,6.36,13.52,14.34,13.52s14.2-6,14.2-13.52c0-5.28-2.7-9.2-8.11-11.5ZM28.55,0H14.21C7.57,11.09,3.65,18.13,2.16,21A17.49,17.49,0,0,0,0,29.09c0,7.57,6.22,13.52,14.2,13.52s14.2-6,14.2-13.52c0-5.28-2.7-9.2-8.11-11.5Z"/>
                </svg>
                <h2>There’s no limit to what a person can accomplish!</h2>
                <h1>

                    <span>SUPPORTING BÉRANGÈRE</span>
                    <span>AND  <em style="color : #d95c74">HIGH-IMPACT</em></span>
                    <span><em style="color : #d95c74">SOCIETAL</em> AND MUTUAL</span>
                    <span>SUPPORT PROJECTS</span>
                </h1>
                <p>
                    Bérangère Pioger is the mother of Honorine, who was diagnosed with a rare genetic disease called lissencephaly at the age of just 7 months. At that point, the Pioger family suddenly discovered the reality of disability care in France, and the lack of appropriate facilities in Normandy, where they still live. “We were devastated, but there was no way we were going to give up!”, says Bérangère. She and her husband got to work immediately, founding a charity and training themselves to stimulate their child. And Honorine began to make progress!  <br><br>
                    When she was 4, her parents came up with the ‘rather crazy idea’ of opening a special school structured to provide care and education for Honorine and other children with multiple disabilities; a school based on the conductive education system. At the time, there was only one school of this type in the country: it was located in central France, and had also been founded by parents. 
                    <br><br>
                    So it was without public funding, but with a great deal of willpower, that Bérangère and her husband embarked on their adventure. They needed to find premises, specialist staff, equipment... and support of all kinds, but particularly financial.  <br><br>
                    Bérangère then met Fabienne Ferey, an elected representative of Groupama, who took an immediate interest in the project. And in 2013, the <span class="marker" :class="item.color">Fondation Groupama</span> provided it with an initial level of financial assistance. That funding began a partnership that continues today. In 2019, Groupama produced a video of Honorine’s story, which has proved hugely successful in the online world. “Groupama gave us the boost we needed and believed in our project, which helps to make people understand that it's feasible and possible!” stresses Bérangère, whose school now cares for 6 children, and is now a recognised facility. Honorine's parents have also helped open 5 other schools.<br><br>
                    As a result, there are now 8 Conductive Education Centres (CECs) with their own federation: the FEPEC.
                </p>

                <div class="link-content">
                    <p style="color : rgb(197, 30, 75); margin-top:30px;">Watch the video produced by Groupama:</p>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/g3LaDbgGA8A" frameborder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen></iframe>
                </div>
                <a href="" class="link">
                    <svg class="link-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 250 324">
                        <path d="M239,260v56a7.89,7.89,0,0,1-8,8H40A40.12,40.12,0,0,1,0,284V40A40.12,40.12,0,0,1,40,0H242c4,0,8,4,8,8V252a7.89,7.89,0,0,1-8,8Zm-16,16V260H40a23.69,23.69,0,0,0-24,24c0,14,10,24,24,24H223V292H37V276Zm11-31V16H40C26,16,16,26,16,40V253c7-5,14-8,24-8Z"/>
                        <path d="M197,64v61H52V64ZM183,78H67v33H183Z"/>
                    </svg>
                   <div class="link-content">
                        <p>To learn more about the facts that marked our year</p>
                        <p><span>DOWNLOAD</span> THE ANNUAL REPORT</p>
                    </div>
                </a>
            </section>
        </article>
    </main>

</template>

<script>

    export default {
        name: "TemoignageBody",
        props: ['item'],
        mounted() {

            window.removeEventListener('scroll', this.scroll)
            window.addEventListener('scroll', this.scroll)

        },
        methods: {
            scroll() {
                if(!document.querySelector('.temoignages-item-bar.active'))
                    return;

                if (this.isInViewport(document.querySelector('.temoignages-item-bar.active')))
                    document.querySelector('.temoignages-item-bar.active + .temoignages-item-content .close').style.opacity = 0;
                else
                    document.querySelector('.temoignages-item-bar.active + .temoignages-item-content .close').style.opacity = 1;
            },
            isInViewport(elem) {
                let bounding = elem.getBoundingClientRect();
                return (
                    bounding.top >= -document.querySelector('.temoignages-item-bar.active').clientHeight &&
                    bounding.left >= 0 &&
                    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
                );
            }
        }
    }
</script>
